import React from 'react';
import { ITables } from '../all-types';
import { TABLE_COLOR_BY_STATUS } from '../constants';

type Props = React.SVGProps<SVGSVGElement> & ITables;

const CircleTableTop: React.FC<Props> = ({
  tableColor = '#000000',
  capacity,
  width = 200,
  height = 200,
  tableNo,
  isActive,
  status,
  ...rest
}) => {
  const radius = Math.min(width, height) / 2 - 10;
  const centerX = width / 2;
  const centerY = height / 2;
  const textColor = '#fff';

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      {/* Circle tabletop */}
      <circle
        cx={centerX}
        cy={centerY}
        r={radius}
        fill={tableColor}
        stroke={TABLE_COLOR_BY_STATUS[status]}
        strokeWidth={6}
      />

      {/* Table number */}
      <text
        x={centerX}
        y={centerY}
        fontSize="30"
        fill={textColor}
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        T{tableNo}
      </text>

      {/* Capacity */}
      {/* <text
        x={centerX}
        y={centerY + 30}
        fontSize="14"
        fill={textColor}
        textAnchor="middle"
      >
        Capacity: {capacity}
      </text> */}

      {/* Status indicators */}
      {/* {status !== "OCCUPIED" && (
        <circle cx={30} cy={30} r={10} fill="red">
          <title>Occupied</title>
        </circle>
      )} */}
      
    </svg>
  );
};

export { CircleTableTop };
